import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { cn } from '../../utils';

type Props = {
  id?: string;
  label?: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  required?: boolean;
  currency?: boolean;
  disabled?: boolean;
};

const Input = ({
  id = uuidv4(),
  label,
  value,
  onChange,
  placeholder = '',
  type = 'text',
  required = false,
  currency = false,
  disabled = false,
}: Props) => {
  return (
    <div className='flex flex-col gap-2'>
      {label && (
        <label
          htmlFor={id}
          className='block text-sm font-semibold text-coral'
        >
          {label}
        </label>
      )}

      <div className='relative w-full'>
        <input
          readOnly={disabled}
          id={id}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className={cn(`
            block h-9 w-full rounded border border-marine-4 bg-coral-9 p-[6px] text-sm font-medium
            text-coral
            placeholder:text-coral-6
            focus:border-marine-4 focus:outline-none focus:ring-0 focus:ring-marine-4
          `,
          currency && 'pr-12',
          disabled && 'select-text caret-transparent',
          )}
        />

        {currency && (
          <div
            className={`
              pointer-events-none absolute right-1 top-1/2 -translate-y-1/2 rounded
              bg-purple-gradient p-1 text-sm font-medium text-white
            `}>
            DAAC
          </div>
        )}
      </div>
    </div>
  );
};

export default Input;
